import { FunctionalComponent, h } from 'preact';
import {
  SubServicesItem,
  SubServicesPlaceholderDetails,
  SubServicesPlaceholderText,
  SubServicesPlaceholderWrapper,
} from './SubServices.styles';
import { Arrow } from '../Arrow';

interface Props {
  size: number;
}

const SubServicePlaceholder: FunctionalComponent<Props> = ({ size }) => {
  return (
    <SubServicesPlaceholderWrapper>
      {Array(size)
        .fill(Math.random())
        .map((id) => {
          return (
            <SubServicesItem key={`sub-placeholder-${id}`}>
              <SubServicesPlaceholderText />
              <SubServicesPlaceholderDetails />
              <Arrow color="rgba(0, 69, 165, 0.5)" direction="right" />
            </SubServicesItem>
          );
        })}
    </SubServicesPlaceholderWrapper>
  );
};

export default SubServicePlaceholder;
